/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import account from "./account-managament/moduleAccountManagement";
import alert from "./alert-management/moduleAlertManagement";
import document from "./document-management/moduleDocumentManagement";
import users from "./users-management/moduleUsersManagement";
import companies from "./companies-management/moduleCompaniesManagement";
import taxData from "./tax-data-management/moduleTaxDataManagement";
import creditPacks from "./credit-packs-management/moduleCreditPacksManagement";
import invoices from "./invoices-management/moduleInvoicesManagement";
import plans from "./plan-management/modulePlanManagement";
import paymentMethods from "./payment-management/modulePaymentManagement";
import documentVerify from "./document-verify-management/moduleDocumentManagement";

Vue.use(Vuex)

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    strict: process.env.NODE_ENV !== 'production',
  modules: {
    account,
    alert,
    document,
    users,
    companies,
    taxData,
    creditPacks,
    invoices,
    plans,
    paymentMethods,
    documentVerify
  }
})
